// extracted by mini-css-extract-plugin
export default {"tabs":"SidebarTabs_tabs__AtJnn","tab":"SidebarTabs_tab__0xG-7","active":"SidebarTabs_active__fSqj2","fit":"SidebarTabs_fit__WAyPh","scroll":"SidebarTabs_scroll__E6bac"};